import React from 'react';
//Iconos
import StorageIcon from '@mui/icons-material/Storage';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmailIcon from '@mui/icons-material/Email';
import BallotIcon from '@mui/icons-material/Ballot';
import LanguageIcon from '@mui/icons-material/Language';
import CloudCircleIcon from '@mui/icons-material/CloudCircle';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StoreIcon from '@mui/icons-material/Store';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import * as SCRNS from 'src/Routes/screens';

const dashBoard = {
   title: SCRNS.SCRN_DASHBOARD.title,
   icon: <DashboardIcon />,
   to: SCRNS.SCRN_DASHBOARD.to,
};

const procesos = {
   title: 'Procesos',
   icon: <AccountTreeIcon />,
   submenu: [
      {
         title: SCRNS.SCRN_GENERAR_LICENCIA.title,
         to: SCRNS.SCRN_GENERAR_LICENCIA.to,
         icon: <VpnKeyIcon />
      },
      {
         title: SCRNS.SCRN_MODIFICAR_LICENCIA.title,
         to: SCRNS.SCRN_MODIFICAR_LICENCIA.to,
         icon: <EditIcon />
      },
      {
         title: SCRNS.SCRN_ACTUALIZACION_MASIVA_LICENCIAS.title,
         to: SCRNS.SCRN_ACTUALIZACION_MASIVA_LICENCIAS.to,
         icon: <DynamicFeedIcon />
      },
      {
         title: SCRNS.SCRN_ADMINISTRAR_LICENCIA.title,
         to: SCRNS.SCRN_ADMINISTRAR_LICENCIA.to,
         icon: <BallotIcon />
      },
      {
         title: SCRNS.SCRN_SUSCRIPCION_NUBE.title,
         to: SCRNS.SCRN_SUSCRIPCION_NUBE.to,
         icon: <CloudCircleIcon />
      }
   ]
};

const reportes = {
   title: 'Reportes',
   icon: <AssessmentIcon />,
   submenu: [
      {
         title: SCRNS.SCRN_LISTAR_LLAVES.title,
         to: SCRNS.SCRN_LISTAR_LLAVES.to,
         icon: <DescriptionIcon />
      },
      {
         title: SCRNS.SCRN_ENVIAR_MAIL.title,
         to: SCRNS.SCRN_ENVIAR_MAIL.to,
         icon: <EmailIcon />
      },
      {
         title: SCRNS.SCRN_HISTORIAL_LICENCIA.title,
         to: SCRNS.SCRN_HISTORIAL_LICENCIA.to,
         icon: <DescriptionIcon />
      }
   ]
};

const mantenimientos = {
   title: 'Configuración',
   icon: <StorageIcon />,
   submenu: [
      {
         title: SCRNS.SCRN_PRODUCTO.title,
         to: SCRNS.SCRN_PRODUCTO.to,
         icon: <DescriptionIcon />
      },
      {
         title: SCRNS.SCRN_VERSION.title,
         to: SCRNS.SCRN_VERSION.to,
         icon: <DescriptionIcon />
      },
      {
         title: SCRNS.SCRN_PRESENTACION.title,
         to: SCRNS.SCRN_PRESENTACION.to,
         icon: <DescriptionIcon />
      },
      {
         title: SCRNS.SCRN_PRODUCTO_DETALLE.title,
         to: SCRNS.SCRN_PRODUCTO_DETALLE.to,
         icon: <DescriptionIcon />
      }
   ]
};

const gestion = {
   title: 'DsCont Cloud',
   icon: <CloudDoneOutlinedIcon />,
   submenu: [
      {
         title: SCRNS.SCRN_ADMINISTRAR_CLIENTES_DSCLOUD.title,
         to: SCRNS.SCRN_ADMINISTRAR_CLIENTES_DSCLOUD.to,
         icon: <DescriptionIcon />
      },
      {
         title: SCRNS.SCRN_GESTIONAR_TIPO_CAMBIO.title,
         to: SCRNS.SCRN_GESTIONAR_TIPO_CAMBIO.to,
         icon: <CurrencyExchangeIcon />
      },
      {
         title: SCRNS.SCRN_GESTIONAR_APPS_DBS.title,
         to: SCRNS.SCRN_GESTIONAR_APPS_DBS.to,
         icon: <ContactPageIcon />
      },
      {
         title: SCRNS.SCRN_BUSCADOR_UUID.title,
         to: SCRNS.SCRN_BUSCADOR_UUID.to,
         icon: <ContentPasteSearchIcon />
      }
   ]
};

const dataTienda = {
   title: 'Tienda Virtual',
   icon: <StoreIcon />,
   submenu: [
      {
         title: SCRNS.SCRN_ABONOS_PASARELA.title,
         to: SCRNS.SCRN_ABONOS_PASARELA.to,
         icon: <CreditCardIcon />
      },
      {
         title: SCRNS.SCRN_REPORTE_CONCILIADOR.title,
         to: SCRNS.SCRN_REPORTE_CONCILIADOR.to,
         icon: <AccountBalanceIcon />
      }
   ]
};

export default [dashBoard, procesos, reportes, mantenimientos, gestion, dataTienda];
